import { staticsUrl } from '../../../config';

export default function (context) {

  const preloadImg = (url) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement('img');
      const imageUrl = staticsUrl + decodeURIComponent(url);
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        context.drawImage(img, 0, 0, width, height);
        resolve({ width, height, url, context });
      }
      img.onerror = () => reject('Failed to load image: ' + url);
      img.setAttribute('src', imageUrl);
    });
  }

  const preloadImages = (exercise) => {
    return new Promise((resolve, reject) => {
      const shiftX = exercise.x;
      const shiftY = exercise.y;
      const imageLocation = exercise.wordLocation ? 'top-left' : 'center';
      const exerciseObj = {
        words: new Array(exercise.words.length).fill(false)
      }
      const pendingTasks = [];

      // Fill exerciseObj with text and sound data
      exercise.words.forEach((item, idx) => {
        exerciseObj.words[idx] = {
          text: item.word.text,
          // translation: item.word.translation,
          mp3Url: item.word.soundUrl,
          oggUrl: item.word.soundOggUrl,
        }
      });
      const loadMainImgPromise = preloadImg(exercise.imageUrl)
        .then(result => {
          exerciseObj.width = result.width;
          exerciseObj.height = result.height;
          exerciseObj.url = result.url;
        })
      pendingTasks.push(loadMainImgPromise);

      // Load all Img1
      exercise.words.forEach((item, idx) => {
        const promise = preloadImg(item.img1.url)
          .then(result => {
            const x = item.img1.x - shiftX - (imageLocation === 'center' ? Math.floor(result.width / 2) : 0);
            const y = item.img1.y - shiftY - (imageLocation === 'center' ? Math.floor(result.height / 2) : 0);
            exerciseObj.words[idx].mainImg = { x, y, ...result };
          })
        pendingTasks.push(promise);
      });

      // Load all Img2
      exercise.words.forEach((item, idx) => {
        if (!item.img2.show) {
          exerciseObj.words[idx].secondaryImg = false;
        } else {
          const promise = preloadImg(item.img2.url)
            .then(result => {
              const x = item.img2.x - shiftX - (imageLocation === 'center' ? Math.floor(result.width / 2) : 0);
              const y = item.img2.y - shiftY - (imageLocation === 'center' ? Math.floor(result.height / 2) : 0);
              exerciseObj.words[idx].secondaryImg = { x, y, ...result }
            })
          pendingTasks.push(promise);
        }
      });


      Promise.all(pendingTasks)
        .then(() => {
          resolve(exerciseObj);
        })
        .catch(e => {
          reject(e);
        })

    });
  }

  return {
    preloadImg,
    preloadImages,
  }

}
